import { notification } from "antd";

function myNotification(message, type) {
  return notification[type]({
    message,
  });
}

export default myNotification;
